/**
 * AuthTransition Component
 *
 * Full-screen branded overlay shown during authentication transitions.
 * Used while the popup is open, before a redirect, or while the Auth0
 * SDK is restoring session state on page load.
 */

import { HeartHandshake } from "lucide-react";

interface AuthTransitionProps {
  message?: string;
}

export function AuthTransition({
  message = "Signing you in...",
}: AuthTransitionProps) {
  return (
    <div className="fixed inset-0 z-[100] flex items-center justify-center bg-background/80 backdrop-blur-sm">
      <div className="flex flex-col items-center gap-6 text-center">
        <div className="flex items-center gap-2">
          <HeartHandshake className="h-8 w-8 text-primary" />
          <span className="text-2xl font-bold text-foreground">AttuneWell</span>
        </div>
        <div className="h-8 w-8 animate-spin rounded-full border-4 border-primary border-r-transparent" />
        <p className="text-sm text-muted-foreground">{message}</p>
      </div>
    </div>
  );
}
